import { z } from "zod";

export const openedPackSchema = z.object({
  sealedQty: z.coerce.number().min(0, "Jumlah utuh minimal 0"),
  packSize: z.coerce.number().min(0, "Ukuran kemasan minimal 0"),
  looseQty: z.coerce.number().min(0, "Sisa terbuka minimal 0"),
  fraction: z.coerce.number().min(0).max(1),
  mode: z.enum(["weight_pieces", "fraction_volume"]),
});

export type OpenedPackFormValues = z.infer<typeof openedPackSchema>;

export const defaultOpenedPackValues: OpenedPackFormValues = {
  sealedQty: 0,
  packSize: 1000,
  looseQty: 0,
  fraction: 0,
  mode: "weight_pieces",
};
